module.exports = __webpack_public_path__ + "prod/1.42.2/img/second-screen.84b8dcd6.png";